export const formatedFileUpload = (item: File[]) => {
    return item.map((attr) => {
      return {
        name: attr.name,
        size: attr.size,
        type: attr.type,
      };
    });
  };